import { defineMessages } from "react-intl";

const VALIDATION = "validation";

const validationMessages = defineMessages({
  validatingMerge: {
    id: `${VALIDATION}.validating-merge`,
    defaultMessage: "Validating merge..."
  }
});

export default validationMessages;
